export function getLocalizedValue(dictionary = {}, key = '') {
  return dictionary[normalizeKey(key)] || key;
}

export function getDefaultLocaleForCluster(cluster = '') {
  if (cluster.toLowerCase().includes('cn')) {
    return 'zh-CN';
  } else {
    return 'en-GB';
  }
}

export const normalizeKey = (key = '') => {
  return key.replaceAll('.', '_');
};
